export default __webpack_public_path__ + "static/media/last_updated_news_announcement.f04191ac.svg";